import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { authConfig } from '@/config/auth.config';

/**
 * Shared oidc-client-ts UserManager singleton.
 *
 * Extracted from AuthProvider so that non-React modules (axios interceptors,
 * the TanStack QueryCache error handler, the session-expiry controller) can
 * drive token renewal and re-login without importing React state.
 *
 * OpenIddict (co-located with the API) owns the token lifetimes
 * (~1h access / ~14d refresh). The client only reacts to expiry — it never
 * tries to change those lifetimes.
 */
export const userManager = new UserManager({
  ...authConfig,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});
